import React, { useState, useEffect } from 'react'
import { Row, Form, Input, Select, Button, Modal, Checkbox, AutoComplete } from 'antd'
import styled from 'styled-components'
import ColorList from '../../../constants/color.constants'
import { getCookie } from 'helper/cookie'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  InboxOutlined,
  LeftOutlined,
  PlusOutlined,
  RightOutlined,
} from '@ant-design/icons'
import '../../../styleLess/signature/projectRole.scss'
import { accountSearch } from 'api/Account/search'
import { getResultPermissionRole } from 'api/Permission/permission'
import {
  getListProjectRole,
  deleteMemberRole,
  projectRoleSave,
  projectRoleEdit,
  saveRole,
  deleteRole,
  EDITROLE_NAME_API_POST,
} from 'api/Project/role'
import { getFileSecurityFromApi } from 'api/OpenFile'
import { useHistory } from 'react-router-dom'
import ButtonStatus from './common/ButtonStatus'
import { Helmet } from 'react-helmet'
import loadingAnimationthreedot from 'icons/three-dots.svg'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
// เดวต้องลบ
const RoleContainer = styled.div``
const HeaderContent = styled.div``
const ContentArea = styled.div``
const FooterContent = styled.div``
const EditModal = styled(Modal)``
const RoleCardV2 = styled.div``
const initalState = {
  data: [],
  isLoading: true,
}
const { Option } = AutoComplete
let id_row = 0
let id_project = 0
const Role = (props) => {
  const {
    swithCaseFunction,
    idEditPRJ,
    role,
    getDataMemberStep1,
    company_id,
    holdtime,
    form,
    setVisibleSaveDraft,
    checkBtn,
  } = props
  const [openCheckbox, setOpenCheckbox] = useState(true)
  const [LeaderOpenCheckbox, setLeaderOpenCheckbox] = useState(false)
  const [groupdash, setGroupdash] = useState(false)
  const [groupsprint, setGroupsprint] = useState(false)
  const [groupkpi, setGroupkpi] = useState(false)
  const [groupapp, setGroupapp] = useState(false)
  const [permissionAll, setPermissionall] = useState(false)
  const [rowSelectAll, setRowSelectAll] = useState(false)
  const [Modalmember, SetModalMember] = useState(false)
  const [ModalVision, setModalVision] = useState(false)
  const [TagArrayData, SetTagArrayData] = useState(initalState.data)
  const [visibleInputRole, setVisibleInputRole] = useState(false)
  const [projectRoleId, setProjectRoleId] = useState()
  const [result, setResult] = useState(initalState.data)
  const [listPermission, setListPermission] = useState(initalState.data)
  const [dataMember, setDataMember] = useState(initalState.data)
  const [firstNameEdit, setFirstNameEdit] = useState()
  const [lastNameEdit, setLastNameEdit] = useState()
  const [userpicture, setUserpicture] = useState()
  const [shortnameCompany, setShortnamecompany] = useState()
  const [modaldeleterowVisible, setModaldeleterowVisible] = useState(false)
  const [skill, setSkill] = useState()
  const [memberId, setMemberId] = useState()
  const [checkPermis, setCheckPermis] = useState('')
  const [defaultPermis, setDefaultPermis] = useState([initalState.data])
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [checkSave, setCheckSave] = useState(initalState.data)
  const [roleNameedit, setRoleNameedit] = useState(false)
  const [dataMemberEdit, setDataMemberEdit] = useState()
  const [visibleRegister, setVisibleRegister] = useState(true)
  const [namemodaltitle, setNamemodaltitle] = useState('Add Role')
  const [waitingData, setWaitingData] = useState(false)
  const [formDefaults] = Form.useForm()
  const [form2] = Form.useForm()
  const token = getCookie('access_token_admin')
  const history = useHistory()
  const isMobielView = useSelector((state) => get(state, 'device.isMobileView', false))

  const blobUrl = async (path) => {
    const response = await getFileSecurityFromApi({ url: path, token: token })
    return URL.createObjectURL(response.data)
  }

  const { Option } = Select
  //checkAll
  const [indeterminate, setIndeterminate] = useState(true)
  const [checkAll, setCheckAll] = useState(false)
  let aaa = []
  listPermission.map((item) => {
    aaa.push(item.id)
  })
  const onCheckAllChange = (e) => {
    if (e.target.checked == true) {
      form2.setFieldsValue({
        editPermission: aaa,
      })
      setCheckPermis(aaa.join(','))
    } else {
      form2.setFieldsValue({
        editPermission: '',
      })
      setCheckPermis('')
    }
    setIndeterminate(false)
    setCheckAll(e.target.checked)
  }
  const onChangeCheckBoxMember = (checkedValues) => {
    setIndeterminate(!!checkedValues.length && checkedValues.length < aaa.length)
    setCheckAll(checkedValues.length === aaa.length)
    let listCheck
    listCheck = checkedValues.join(',')
    setCheckPermis(listCheck)
  }
  const editMember = async (data) => {
    let checkList = data.permission.split(',')
    var result = checkList.map((item) => parseInt(item))
    let newPerm = []
    checkList.map((item) => {
      if (item != '') {
        newPerm.push(item)
      }
    })
    if (newPerm.length == 0) {
      await setIndeterminate(false)
      await setCheckAll(false)
    } else if (newPerm.length > 0 && newPerm.length < 4) {
      await setCheckAll(false)
      await setIndeterminate(true)
    } else {
      await setIndeterminate(false)
      await setCheckAll(true)
    }
    form2.setFieldsValue({
      editPermission: result,
    })

    const JoinPermission = newPerm.join(',')
    const newPictUrl = setCheckPermis(JoinPermission)
    setDefaultPermis(data.permission)
    setDataMemberEdit(data)
    SetModalMember(true)
    setMemberId(data.account_id)
    setProjectRoleId(data.projectrole_id)
    setFirstNameEdit(data.firstname)
    setLastNameEdit(data.lastname)
    setSkill(data.skill)
    setUserpicture(data.pic_display)
    setShortnamecompany(data.company_short_name || data.company_name_en)
  }
  const cancleModalMember = () => {
    form2.setFieldsValue({
      checkbox_edit: [],
    })
    SetModalMember(false)
  }
  const EventUseModal = async (item) => {
    if (role === false) {
      setCheckSave('addMember')
      setProjectRoleId(item.id)
      formDefaults.setFieldsValue({
        checkListPermission: null,
      })
      formDefaults.setFieldsValue({
        form_autocomplete: null,
      })
      SetTagArrayData([])
      if (item != null) {
        formDefaults.setFieldsValue({
          Input_role: item.role_name,
        })
        setVisibleInputRole(true)
      } else {
        formDefaults.setFieldsValue({
          Input_role: null,
        })
        setVisibleInputRole(false)
      }
      await setGroupdash(false)
      await setGroupsprint(false)
      await setGroupkpi(false)
      await setGroupapp(false)
      await setOpenCheckbox(true)
      await setModalVision(true)
      await setLeaderOpenCheckbox(true)
      await setPermissionall(false)
    }
  }
  const getDataMember = async () => {
    await getListProjectRole({
      project_id: idEditPRJ,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (data[0].member != null) {
          setVisibleRegister(false)
        } else {
          setVisibleRegister(true)
        }
        if (error) {
          await setDataMember([])
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          getDataMemberStep1()
          props.getroleAuthority()
          await setDataMember(data)
          await setIsLoading(false)
          setWaitingData(true)
        } else {
          setDataMember([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataMember([])
        setIsLoading(false)
        console.error(error)
      })
  }
  const getListDataPermission = async () => {
    await getResultPermissionRole({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setListPermission([])
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          getDataMemberStep1()
          let arayRole = []
          data.map((i) => {
            if (i.id == 1) {
              const j = {
                id: i.id,
                kind: i.role,
                title: 'Overview',
              }
              arayRole.push(j)
            } else {
              arayRole.push(i)
            }
          })
          props.getroleAuthority()
          await setListPermission(arayRole)
          await setIsLoading(false)
        } else {
          setListPermission([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setListPermission([])
        setIsLoading(false)
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      if (holdtime === true) {
        getListDataPermission()
        getDataMember()
      }
    }
  }, [token, holdtime])
  const handleCancel = () => {
    setModalVision(false)
  }
  const handleAddRole = () => {
    SetTagArrayData(initalState.data)
    setCheckSave('addRole')
    formDefaults.setFieldsValue({
      Input_role: null,
      form_autocomplete: '',
      checkListPermission: null,
    })
    setNamemodaltitle('Add Role')
    setVisibleInputRole(false)
    setOpenCheckbox(true)
    setGroupdash(false)
    setGroupsprint(false)
    setGroupkpi(false)
    setGroupapp(false)
    setLeaderOpenCheckbox(true)
    setPermissionall(false)
    setModalVision(true)
  }
  let Datauser = []
  const onFinish = (value) => {
    setModalVision(false)
    TagArrayData.map((go) => {
      var permmisarray = []
      go.authority.map((item) => {
        if (item.dashboard === true) {
          permmisarray.push(1)
        }
        if (item.sprintflow === true) {
          permmisarray.push(2)
        }
        if (item.kpi === true) {
          permmisarray.push(3)
        }
        if (item.approval === true) {
          permmisarray.push(4)
        }
      })
      const newdata = { account_id: go.id, permission: `${permmisarray}` }
      Datauser.push(newdata)
    })
    const dataAddMember = {
      project_id: parseInt(idEditPRJ),
      projectrole_id: projectRoleId,
      mapping: Datauser.map((data) => ({
        account_id: data.account_id,
        permission: data.permission,
      })),
    }
    if (checkSave === 'addMember') {
      try {
        saveRole({
          params: dataAddMember,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            getDataMemberStep1()
            props.getroleAuthority()
            getDataMember()
            setModalVision(false)
            setOpenCheckbox(true)
            setGroupdash(false)
            setGroupsprint(false)
            setGroupkpi(false)
            setGroupapp(false)
            setOpenCheckbox(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
    const dataAddRole = {
      project_id: parseInt(idEditPRJ),
      role_name: value.Input_role,
    }
    if (checkSave === 'addRole') {
      try {
        projectRoleSave({
          params: dataAddRole,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            getDataMemberStep1()
            props.getroleAuthority()
            const dataAddMember = {
              project_id: parseInt(idEditPRJ),
              projectrole_id: res.data.id,
              mapping: Datauser.map((data) => ({
                account_id: data.account_id,
                permission: data.permission,
              })),
            }
            try {
              saveRole({
                params: dataAddMember,
                token: token,
              }).then((res) => {})
            } catch (error) {
              console.log(error)
            }
            getDataMember()
            setOpenCheckbox(true)
            setGroupdash(false)
            setGroupsprint(false)
            setGroupkpi(false)
            setGroupapp(false)
            setOpenCheckbox(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }

    if (roleNameedit === true) {
      const newDataeditrole = {
        project_id: parseInt(idEditPRJ),
        role_name: value.Input_role,
        role_id: projectRoleId,
      }
      try {
        EDITROLE_NAME_API_POST({
          params: newDataeditrole,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setRoleNameedit(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
  // *** Edit ยิง api save member เหมือนกัน แต่จะไม่ mapping account
  const onFinishEdit = () => {
    const dataArray = {
      project_id: parseInt(idEditPRJ),
      projectrole_id: projectRoleId,
      mapping: [
        {
          account_id: dataMemberEdit.account_id,
          permission: checkPermis,
        },
      ],
    }
    try {
      projectRoleEdit({
        params: dataArray,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getDataMemberStep1()
          props.getroleAuthority()
          getDataMember()
        }
        SetModalMember(false)
      })
    } catch (error) {
      console.log(error)
    }
  }
  const onSelect = async (val, item) => {
    userSelected(item.data)
  }
  const userSelected = async (data) => {
    var addData = true

    for (var i = 0; i < TagArrayData.length; i++) {
      if (TagArrayData[i].id == data.id) {
        addData = false
      }
    }
    if (addData) {
      const newPictUrl = await blobUrl(data.pic_display)
      const newTagArrayData = [
        ...TagArrayData,
        {
          id: data.id,
          firstname: data.firstname,
          lastname: data.lastname,
          pic_display: newPictUrl,
          controllerRowperrmission: true,
          disabledStyle: true,
          authority: [{ dashboard: true, sprintflow: true, kpi: true, approval: true }],
        },
      ]
      SetTagArrayData(newTagArrayData)
      // Check if all members have all permissions
      const allHaveAllPermissions = newTagArrayData.every(
        (item) => item.controllerRowperrmission === true,
      )
      if (allHaveAllPermissions) {
        setGroupdash(true)
        setGroupsprint(true)
        setGroupkpi(true)
        setGroupapp(true)
        setPermissionall(true)
        setOpenCheckbox(true)
      } else {
        setGroupdash(false)
        setGroupsprint(false)
        setGroupkpi(false)
        setGroupapp(false)
        setPermissionall(false)
        setOpenCheckbox(false)
      }
    } else {
      setGroupdash(false)
      setGroupsprint(false)
      setGroupkpi(false)
      setGroupapp(false)
      setPermissionall(false)
      setOpenCheckbox(false)
    }
    setLeaderOpenCheckbox(false)
  }
  const handleSearch = async (value) => {
    // let res = []
    // console.log(value)
    if (value.length >= 3) {
      const data = {
        search: value,
      }
      // if (!value) {
      //   setResult([])
      // } else {
      try {
        await accountSearch({
          params: data,
          projectID: idEditPRJ,
          token: token,
          // comid: company_id,
        }).then((response) => {
          const { status, data, error } = response
          // console.log(data)
          if (error) {
            setResult([])
            setIsLoading(false)
            return true
          }
          if (status === 200) {
            getDataMemberStep1()
            props.getroleAuthority()
            setResult(data.data)
            setIsLoading(false)
          } else {
            setResult([])
            setIsLoading(false)
            return true
          }
        })
      } catch (error) {
        setResult([])
        setIsLoading(false)
        console.log(error)
      }
      // }
    } else {
      setResult([])
    }
  }
  const checkIcon = (data, item) => {
    var str = data.permission
    var keySearch = item.id
    if (str.includes(keySearch)) {
      return <CheckCircleOutlined className={'CheckCircleOutlined'} />
    } else {
      return <CloseCircleOutlined className={'CloseCircleOutlined'} />
    }
  }
  const setProperty_to_deleteRows = (values) => {
    setModaldeleterowVisible(true)

    id_row = values.id
    id_project = values.project_id
  }
  const deleteRoleFunctional = () => {
    const data = {
      project_id: id_project,
      row: id_row,
    }
    try {
      deleteRole({
        params: data,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          setModaldeleterowVisible(false)
          getDataMember()
        }
      })
    } catch (error) {
      console.log(error)
    }
  }
  const deleteMember = () => {
    const data = {
      project_id: parseInt(idEditPRJ),
      projectrole_id: projectRoleId,
      account_id: memberId,
    }
    try {
      deleteMemberRole({
        params: data,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getDataMemberStep1()
          props.getroleAuthority()
          getDataMember()
        }
        SetModalMember(false)
      })
    } catch (error) {
      console.log(error)
    }
  }
  const checkLength = (member) => {
    if (member === null) {
      return <>(0)</>
    } else {
      return <>({member.length})</>
    }
  }
  let arrayPermis = []
  const Editrolemember = async (item) => {
    setNamemodaltitle('Edit Role')
    setCheckSave('addMember')
    setProjectRoleId(item.id)
    // SetTagArrayData(item.member)
    // เขียน Data ใหม่
    if (item.member !== null) {
      let controller = false
      let disUse = false
      let getDash = false
      let getsprint = false
      let getkpi = false
      let getappro = false
      item.member.map((user) => {
        var authority = user.permission
        if (authority != null) {
          // authority = authority.substring(1, authority.length - 1)
          var array_authority = authority.split(',')

          array_authority.map((item) => {
            if (item == 1) {
              getDash = true
            }
            if (item == 2) {
              getsprint = true
            }
            if (item == 3) {
              getkpi = true
            }
            if (item == 4) {
              getappro = true
            }
          })
          if (
            getDash === true &&
            getsprint === true &&
            getkpi === true &&
            getappro === true
          ) {
            disUse = true
            controller = true
          } else {
            disUse = false
            controller = false
          }
        }
        const newData = {
          id: user.account_id,
          firstname: user.firstname,
          lastname: user.lastname,
          pic_display: user.pic_display,
          //เพิ่ม check row
          controllerRowperrmission: controller,
          //เพิ่ม check row
          // เพิ่ม ไว้ check  disabled
          disabledStyle: disUse,
          // เพิ่ม ไว้ check  disabled
          authority: [
            {
              dashboard: getDash,
              sprintflow: getsprint,
              kpi: getkpi,
              approval: getappro,
            },
          ],
        }
        getDash = false
        getsprint = false
        getkpi = false
        getappro = false
        arrayPermis.push(newData)
      })
    }
    await SetTagArrayData(arrayPermis)

    formDefaults.setFieldsValue({
      checkListPermission: null,
    })
    formDefaults.setFieldsValue({
      form_autocomplete: null,
    })
    // SetTagArrayData([])
    if (item != null) {
      formDefaults.setFieldsValue({
        Input_role: item.role_name,
      })
    } else {
      formDefaults.setFieldsValue({
        Input_role: null,
      })
    }
    // มาเช็คว่าควรให้ input เปิดให้แก้ไขหรือไม่ โดยเช็คจาก project_id
    // ถ้า project_id = 0 คือ default role ให้ disable, ถ้าไม่เท่ากับ 0 ให้แก้ไขได้
    if (item.project_id !== 0) {
      setRoleNameedit(true)
      setVisibleInputRole(false)
    } else {
      setRoleNameedit(false)
      setVisibleInputRole(true)
    }
    // เช็คว่า ติ้กครบให้เติม
    await EjectGroupCheckbox(arrayPermis)

    setModalVision(true)
  }

  const EjectGroupCheckbox = async (item) => {
    let countDash = 0
    let countSprint = 0
    let countKpi = 0
    let countapproval = 0
    let countAllpermission = 0
    if (item.length != 0) {
      item.map((stringValue) => {
        if (stringValue.controllerRowperrmission === true) {
          countAllpermission = countAllpermission + 1
        }

        stringValue.authority.map((item) => {
          if (item.dashboard === false) {
            setGroupdash(false)
          } else if (item.dashboard === true) {
            countDash = countDash + 1
          }
          if (item.sprintflow === false) {
            setGroupsprint(false)
          } else if (item.sprintflow === true) {
            countSprint = countSprint + 1
          }
          if (item.kpi === false) {
            setGroupkpi(false)
          } else if (item.kpi === true) {
            countKpi = countKpi + 1
          }
          if (item.approval === false) {
            setGroupapp(false)
          } else if (item.approval === true) {
            countapproval = countapproval + 1
          }
        })
      })
      setLeaderOpenCheckbox(false)
      // setOpenCheckbox(false)
      if (countAllpermission == item.length) {
        setPermissionall(true)
        setOpenCheckbox(true)
      } else {
        setPermissionall(false)
        setOpenCheckbox(false)
        // setLeaderOpenCheckbox(f)
      }
      if (countDash == item.length) {
        setGroupdash(true)
      }
      if (countSprint == item.length) {
        setGroupsprint(true)
      }
      if (countKpi == item.length) {
        setGroupkpi(true)
      }
      if (countapproval == item.length) {
        setGroupapp(true)
      }
    } else {
      await setGroupsprint(false)
      await setGroupdash(false)
      await setGroupkpi(false)
      await setGroupapp(false)
      await setPermissionall(false)
      await setOpenCheckbox(true)
      await setLeaderOpenCheckbox(true)
    }
  }
  let arrayIdforQuerySearchBlock = []
  const renderMember = (item) => {
    if (item.member === null) {
      return (
        <div
          id={`RoleID_${item.id}`}
          onClick={() => EventUseModal(item)}
          className="BoxDashed"
        >
          <PlusOutlined className="PlusOutlined" />
          <h3>Add Member</h3>
        </div>
      )
    } else {
      return item.member.map((data, index) => {
        arrayIdforQuerySearchBlock.push(data.account_id)
        return (
          <RoleCardV2 className="container-rolecardv2">
            <div className="group-left">
              <div className="a">
                <img src={data.pic_display} className="imageStyle"></img>
              </div>
              <div className="b">
                <div style={{ display: 'grid' }}>
                  <h4 className="cutter-text-line-1">
                    {data.firstname} {data.lastname}
                  </h4>
                </div>
                <div style={{ display: 'grid' }}>
                  <span
                    style={{ height: 16 }}
                    className="small color-small cutter-text-line-1"
                  >
                    {data.skill}
                  </span>
                  <span className="small cutter-text-line-1">
                    Business : {data.company_short_name || data.company_name_en}
                  </span>
                </div>
                <div className="permission-container">
                  {listPermission.map((item, index) => (
                    <span className="small stylesPosition">
                      {checkIcon(data, item)}
                      {item.title}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="c">
              <EditOutlined
                id="edit_member"
                className="Editoutlined"
                hidden={role}
                onClick={() => editMember(data)}
              />
            </div>
          </RoleCardV2>
        )
      })
    }
  }
  const HeadRowFuncSelect = (value) => {
    setPermissionall(value.target.checked)
    if (value.target.checked === true) {
      setGroupdash(true)
      setGroupsprint(true)
      setGroupkpi(true)
      setGroupapp(true)
      setOpenCheckbox(true)
      TagArrayData.map((item1) => {
        SetTagArrayData([
          ...TagArrayData,
          item1.authority.map((item) => {
            item.dashboard = true
            item.sprintflow = true
            item.kpi = true
            item.approval = true
            item1.controllerRowperrmission = true
            item1.disabledStyle = true
          }),
        ])
      })
    } else {
      setGroupdash(false)
      setGroupsprint(false)
      setGroupkpi(false)
      setGroupapp(false)
      setOpenCheckbox(false)
      TagArrayData.map((item1) => {
        SetTagArrayData([
          ...TagArrayData,
          item1.authority.map((item) => {
            item.dashboard = false
            item.sprintflow = false
            item.kpi = false
            item.approval = false
            item1.disabledStyle = false
            item1.controllerRowperrmission = false
          }),
        ])
      })
    }
    const newdata = TagArrayData.filter((item) => item != undefined)
    SetTagArrayData(newdata)
  }
  const rowFuncSelect = (value) => {
    TagArrayData.map((data) => {
      if (data.id === value.target.data.id) {
        if (data.controllerRowperrmission === false) {
          SetTagArrayData([...TagArrayData, (data.controllerRowperrmission = true)])
        } else if (data.controllerRowperrmission === true) {
          SetTagArrayData([...TagArrayData, (data.controllerRowperrmission = false)])
        }
      }
    })
    //#################### new func all permission ####################
    if (value.target.checked === true) {
      TagArrayData.map((data) => {
        if (data.id === value.target.data.id) {
          SetTagArrayData([
            ...TagArrayData,
            data.authority.map((item) => {
              // DASHBOARD SELECT = TRUE
              if (item.dashboard === false) {
                item.dashboard = true
              }
              // Sprint(task)flow SELECT = TRUE
              if (item.sprintflow === false) {
                item.sprintflow = true
              }
              // KPI SELECT = TRUE
              if (item.kpi === false) {
                item.kpi = true
              }
              // Approval SELECT = TRUE
              if (item.approval === false) {
                item.approval = true
              }
            }),
          ])
        }
      })
    } else if (value.target.checked === false) {
      TagArrayData.map((data) => {
        if (data.id === value.target.data.id) {
          SetTagArrayData([
            ...TagArrayData,
            data.authority.map((item) => {
              // DASHBOARD SELECT = TRUE
              if (item.dashboard === true) {
                item.dashboard = false
              }
              // Sprint(task)flow SELECT = TRUE
              if (item.sprintflow === true) {
                item.sprintflow = false
              }
              // KPI SELECT = TRUE
              if (item.kpi === true) {
                item.kpi = false
              }
              // Approval SELECT = TRUE
              if (item.approval === true) {
                item.approval = false
              }
            }),
          ])
        }
      })
    }
    const newdata = TagArrayData.filter((item) => item != undefined)
    SetTagArrayData(newdata)
    MapforcheckStatecheckbox('rowFuncSelect', value.target.data.id)
    //#################### new func all permission ####################
  }
  const selectCustom = (value) => {
    if (value.target.value === 'dashboard') {
      TagArrayData.map((data) => {
        if (data.id === value.target.data.id) {
          SetTagArrayData([
            ...TagArrayData,
            data.authority.map((item) => {
              if (item.dashboard === true) {
                item.dashboard = false
              } else if (item.dashboard === false) {
                item.dashboard = true
              }
            }),
          ])
        }
      })
    }
    if (value.target.value === 'sprintflow') {
      TagArrayData.map((data) => {
        if (data.id === value.target.data.id) {
          SetTagArrayData([
            ...TagArrayData,
            data.authority.map((item) => {
              if (item.sprintflow === true) {
                item.sprintflow = false
              } else if (item.sprintflow === false) {
                item.sprintflow = true
              }
            }),
          ])
        }
      })
    }
    if (value.target.value === 'kpi') {
      TagArrayData.map((data) => {
        if (data.id === value.target.data.id) {
          SetTagArrayData([
            ...TagArrayData,
            data.authority.map((item) => {
              if (item.kpi === true) {
                item.kpi = false
              } else if (item.kpi === false) {
                item.kpi = true
              }
            }),
          ])
        }
      })
    }
    if (value.target.value === 'approval') {
      TagArrayData.map((data) => {
        if (data.id === value.target.data.id) {
          SetTagArrayData([
            ...TagArrayData,
            data.authority.map((item) => {
              if (item.approval === true) {
                item.approval = false
              } else if (item.approval === false) {
                item.approval = true
              }
            }),
          ])
        }
      })
    }
    const newdata = TagArrayData.filter((item) => item != undefined)
    SetTagArrayData(newdata)

    // EjectGroupCheckbox()
    MapforcheckStatecheckbox('from_selectcustom', value.target.data.id)
  }
  const selectAll = (value) => {
    if (value.target.value === 'dashboard') {
      setGroupdash(!groupdash)
      TagArrayData.map((data) => {
        SetTagArrayData([
          ...TagArrayData,
          data.authority.map((item) => {
            if (groupdash === false) {
              item.dashboard = true
            } else if (groupdash === true) {
              item.dashboard = false
            }
          }),
        ])
      })
    }
    if (value.target.value === 'sprintflow') {
      setGroupsprint(!groupsprint)
      TagArrayData.map((data) => {
        SetTagArrayData([
          ...TagArrayData,
          data.authority.map((item) => {
            if (groupsprint === false) {
              item.sprintflow = true
            } else if (groupsprint === true) {
              item.sprintflow = false
            }
          }),
        ])
      })
    }
    if (value.target.value === 'kpi') {
      setGroupkpi(!groupkpi)
      TagArrayData.map((data) => {
        SetTagArrayData([
          ...TagArrayData,
          data.authority.map((item) => {
            if (groupkpi === false) {
              item.kpi = true
            } else if (groupkpi === true) {
              item.kpi = false
            }
          }),
        ])
      })
    }
    if (value.target.value === 'approval') {
      setGroupapp(!groupapp)
      TagArrayData.map((data) => {
        SetTagArrayData([
          ...TagArrayData,
          data.authority.map((item) => {
            if (groupapp === false) {
              item.approval = true
            } else if (groupapp === true) {
              item.approval = false
            }
          }),
        ])
      })
    }
    // new function ##############################
    if (value.target.value === 'allpermission') {
      setPermissionall(!permissionAll)
      setRowSelectAll(!rowSelectAll)
    }
    // new function ##############################
    const newdata = TagArrayData.filter((item) => item != undefined)
    SetTagArrayData(newdata)
    TagArrayData.map((data) => {
      SetTagArrayData([
        ...TagArrayData,
        data.authority.map((item) => {
          if (
            item.dashboard === true &&
            item.sprintflow === true &&
            item.kpi === true &&
            item.approval === true
          ) {
            data.disabledStyle = true
            data.controllerRowperrmission = true
          } else {
            data.disabledStyle = false
            data.controllerRowperrmission = false
          }
        }),
      ])
    })
    let statecount_permission = 0
    TagArrayData.map((j) => {
      if (j.controllerRowperrmission === true) {
        statecount_permission = statecount_permission + 1
      }
    })
    if (statecount_permission == TagArrayData.length) {
      setPermissionall(true)
      setOpenCheckbox(true)
    } else {
      setPermissionall(false)
      setOpenCheckbox(false)
    }
    const newdata2 = TagArrayData.filter((item) => item != undefined)
    SetTagArrayData(newdata2)
  }
  const MapforcheckStatecheckbox = (text, id) => {
    TagArrayData.map((data) => {
      if (data.id === id) {
        SetTagArrayData([
          ...TagArrayData,
          data.authority.map((item) => {
            if (
              item.dashboard === true &&
              item.sprintflow === true &&
              item.kpi === true &&
              item.approval === true
            ) {
              data.disabledStyle = true
              data.controllerRowperrmission = true
            } else {
              data.disabledStyle = false
              data.controllerRowperrmission = false
            }
          }),
        ])
      }
    })
    let countDash = 0
    let countSprint = 0
    let countKpi = 0
    let countapproval = 0
    let allPerm = 0

    TagArrayData.map((stringValue) => {
      if (stringValue.controllerRowperrmission === true) {
        allPerm = allPerm + 1
      }
      stringValue.authority.map((item) => {
        if (item.dashboard === false) {
          setGroupdash(false)
        } else if (item.dashboard === true) {
          countDash = countDash + 1
        }
        if (item.sprintflow === false) {
          setGroupsprint(false)
        } else if (item.sprintflow === true) {
          countSprint = countSprint + 1
        }
        if (item.kpi === false) {
          setGroupkpi(false)
        } else if (item.kpi === true) {
          countKpi = countKpi + 1
        }
        if (item.approval === false) {
          setGroupapp(false)
        } else if (item.approval === true) {
          countapproval = countapproval + 1
        }
      })
    })
    // ข้างบน
    if (allPerm == TagArrayData.length) {
      setPermissionall(true)
      setOpenCheckbox(true)
    } else {
      setPermissionall(false)
      setOpenCheckbox(false)
    }
    if (countDash == TagArrayData.length) {
      setGroupdash(true)
    }
    if (countSprint == TagArrayData.length) {
      setGroupsprint(true)
    }
    if (countKpi == TagArrayData.length) {
      setGroupkpi(true)
    }
    if (countapproval == TagArrayData.length) {
      setGroupapp(true)
    }
    const newdata = TagArrayData.filter((item) => item != undefined)
    SetTagArrayData(newdata)
  }
  const handleDeleteCard = (id) => {
    const Delete = TagArrayData.filter((item) => item.id != id)
    SetTagArrayData(Delete)
    let countDash = 0
    let countSprint = 0
    let countKpi = 0
    let countapproval = 0
    Delete.map((stringValue) => {
      stringValue.authority.map((item) => {
        if (item.dashboard === false) {
          setGroupdash(false)
        } else if (item.dashboard === true) {
          countDash = countDash + 1
        }
        if (item.sprintflow === false) {
          setGroupsprint(false)
        } else if (item.sprintflow === true) {
          countSprint = countSprint + 1
        }
        if (item.kpi === false) {
          setGroupkpi(false)
        } else if (item.kpi === true) {
          countKpi = countKpi + 1
        }
        if (item.approval === false) {
          setGroupapp(false)
        } else if (item.approval === true) {
          countapproval = countapproval + 1
        }
      })
    })
    if (countDash == Delete.length) {
      setGroupdash(true)
    }
    if (countSprint == Delete.length) {
      setGroupsprint(true)
    }
    if (countKpi == Delete.length) {
      setGroupkpi(true)
    }
    if (countapproval == Delete.length) {
      setGroupapp(true)
    }
    if (TagArrayData.length <= 1) {
      setOpenCheckbox(true)
      setGroupdash(false)
      setGroupsprint(false)
      setGroupkpi(false)
      setGroupapp(false)
      setPermissionall(false)
      setLeaderOpenCheckbox(true)
    }
  }
  const authorityFunction = (data) => {
    if (data.authority != undefined) {
      return data.authority.map((type) => {
        return (
          <div className="group-type ">
            <div className="box-width-a">
              <Checkbox
                id="user-checkbox-all-permission"
                onChange={rowFuncSelect}
                data={data}
                value="row-select-all-permission"
                checked={data.controllerRowperrmission}
              ></Checkbox>
            </div>
            <div className="box-width-b">
              <Checkbox
                id="user-checkbox-dashboard"
                checked={type.dashboard}
                onChange={selectCustom}
                data={data}
                value="dashboard"
                disabled={data.disabledStyle}
              ></Checkbox>
            </div>
            <div className="box-width-c">
              <Checkbox
                id="user-checkbox-sprintflow"
                checked={type.sprintflow}
                data={data}
                value="sprintflow"
                onChange={selectCustom}
                disabled={data.disabledStyle}
              ></Checkbox>
            </div>
            <div className="box-width-d">
              <Checkbox
                id="user-checkbox-kpi"
                checked={type.kpi}
                data={data}
                value="kpi"
                onChange={selectCustom}
                disabled={data.disabledStyle}
              ></Checkbox>
            </div>
            <div className="box-width-e">
              <Checkbox
                id="user-checkbox-approval"
                checked={type.approval}
                data={data}
                value="approval"
                onChange={selectCustom}
                disabled={data.disabledStyle}
              ></Checkbox>
            </div>
            <div className="box-width-f ">
              <DeleteOutlined
                id="user-checkbox-delete"
                className="deleteoutlined"
                onClick={() => handleDeleteCard(data.id)}
              />
            </div>
          </div>
        )
      })
    }
  }
  const Datarender = () => {
    if (TagArrayData.length == 0) {
      return (
        <div className="nodata-container">
          <InboxOutlined className="inboxoutlined" />
          <p>No Data</p>
        </div>
      )
    } else {
      return TagArrayData.map((data) => {
        return (
          <div className="row-user-group">
            <div className="row-left">
              <img className="imageStyle" src={data.pic_display}></img>
              <p>
                {data.firstname} {data.lastname}
              </p>
            </div>
            {authorityFunction(data)}
          </div>
        )
      })
    }
  }
  const onFinishSave = () => {
    if (checkBtn == 'save') {
      setVisibleSaveDraft(true)
    }
  }
  const onClickPrevious = () => {
    swithCaseFunction('skill')
    history.push(`/project/${idEditPRJ}/skill`)
  }
  const onClickNext = () => {
    swithCaseFunction('kpi')
    history.push(`/project/${idEditPRJ}/kpi`)
  }
  return (
    <RoleContainer style={{ height: '100%' }}>
      <Helmet>
        <title>Create Project | Role</title>
      </Helmet>
      <Form form={form} onFinish={onFinishSave}></Form>
      <Form className="layout-Form" name="register_step2" form={formDefaults}>
        <div className="group">
          {/* <p>Information is required before the project can be executed.</p> */}
          <HeaderContent
            style={{ display: !isMobielView && 'block', justifyContent: 'space-between' }}
          >
            <div className="header" style={{ marginBottom: '0px', marginTop: '0px' }}>
              <h2>Project Role</h2>
              <div className="header" style={{ marginTop: '10px', marginBottom: '0px' }}>
                <p>Information is required before the project can be executed.</p>
              </div>
            </div>
            <div
              style={{
                width: '100%',
                textAlign: 'end',
                marginTop: isMobielView ? '0px' : '-40px',
              }}
            >
              <Button
                style={{ marginTop: isMobielView ? '10px' : '0px' }}
                id="addrole"
                className="BTN_Next"
                type="primary"
                icon={<PlusOutlined className="Icon-color" />}
                hidden={role}
                onClick={() => handleAddRole()}
              >
                Add Role
              </Button>
            </div>
          </HeaderContent>
          {holdtime === true && waitingData === true ? (
            <ContentArea className="map-role-and-member-container">
              {dataMember.map((item, index) => {
                return (
                  <div style={{ width: '100%' }}>
                    <div style={{ display: 'grid' }}>
                      <h3
                        className="title cutter-text-line-1"
                        style={{ color: '#074E9F' }}
                      >
                        {item.role_name} {checkLength(item.member)}
                        <EditOutlined
                          id={`edit_RoleID_${item.id}`}
                          hidden={role}
                          style={{ color: ColorList.darkgray, marginLeft: 10 }}
                          onClick={() => Editrolemember(item)}
                        />
                        {item.project_id !== 0 ? (
                          <DeleteOutlined
                            hidden={role}
                            id={`Delete_RoleID_${index}`}
                            className="delete-row-icon"
                            onClick={() => setProperty_to_deleteRows(item)}
                          />
                        ) : (
                          ' '
                        )}
                      </h3>
                    </div>
                    <div className="grid-layout-card-member-item">
                      {renderMember(item)}
                    </div>
                  </div>
                )
              })}
            </ContentArea>
          ) : (
            <div className="container-waiting-load">
              <img src={loadingAnimationthreedot}></img>
            </div>
          )}
        </div>
        <FooterContent
          style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 32 }}
        >
          <Button
            id="previousrole"
            type="primary"
            className="BTN_Previous"
            onClick={() => onClickPrevious()}
            style={{ marginRight: 8 }}
          >
            <LeftOutlined className="Icon-color" />
            Previous
          </Button>
          <Button
            id="nextrole"
            type="primary"
            className="BTN_Next "
            onClick={() => onClickNext()}
          >
            Next
            <RightOutlined className="Icon-color" />
          </Button>
        </FooterContent>
        <EditModal
          maskClosable={false}
          className="editmodal"
          title={
            <h2 style={{ fontFamily: 'IBMPlexSansThaiBold' }} className="Modaltitle">
              {namemodaltitle}
            </h2>
          }
          visible={ModalVision}
          onOk={formDefaults.submit}
          okText={'Save'}
          onCancel={handleCancel}
        >
          <Form name="Add_role" form={formDefaults} onFinish={onFinish}>
            <div className="ContainerBox">
              <h4 className="label">Role name</h4>
              <Form.Item
                className="disable-page"
                id="Input_role"
                name="Input_role"
                rules={[
                  {
                    whitespace: true,
                    required: true,
                    message: '*Please enter your role name',
                  },
                ]}
              >
                <Input
                  id="Role_name"
                  placeholder="Role name"
                  disabled={visibleInputRole}
                />
              </Form.Item>
              <h4 className="label">Add Member</h4>
              <Form.Item
                style={{ margin: 0 }}
                id="form_autocomplete"
                name="form_autocomplete"
              >
                <AutoComplete
                  id="autocomplete"
                  onSelect={onSelect}
                  onSearch={handleSearch}
                  placeholder="Select a person"
                  allowClear
                  // notFoundContent={<div>Not found a person</div>}
                >
                  {result
                    .filter((itemidfiltering) => {
                      let k = 0
                      arrayIdforQuerySearchBlock.map((item) => {
                        if (item == itemidfiltering.id) {
                          k = item
                        }
                      })
                      if (itemidfiltering.id != k) {
                        return itemidfiltering
                      }
                    })
                    .map((item) => (
                      <Option
                        key={item.id}
                        data={item}
                        value={item.firstname + ' ' + item.lastname}
                      >
                        {/* {console.log(item)} */}
                        <Row style={{ justifyContent: 'space-between' }}>
                          <span>
                            {item.firstname} {item.lastname}
                          </span>
                          <span>{item.companyname_short || item.companyname_en}</span>
                        </Row>
                      </Option>
                    ))}
                </AutoComplete>
              </Form.Item>
              <div className="AfterAdditem">
                <div className="table">
                  <div className="table-topic">
                    <div>
                      <div className="column-table-a ">
                        <h5>Name</h5>
                      </div>
                    </div>
                    <div className="grid-column-gap">
                      <div className="column-table-b">
                        <Checkbox
                          id="permission-all"
                          value="allpermission"
                          onChange={HeadRowFuncSelect}
                          checked={permissionAll}
                          disabled={LeaderOpenCheckbox}
                        />
                        <h5>All Permission</h5>
                      </div>
                      <div className="column-table-c  ">
                        <Checkbox
                          id="permission-dashboard"
                          value="dashboard"
                          onChange={selectAll}
                          checked={groupdash}
                          disabled={openCheckbox}
                          // disabled={true}
                        />
                        <h5>Overview</h5>
                      </div>
                      <div className="column-table-d  ">
                        <Checkbox
                          id="permission-sprintflow"
                          value="sprintflow"
                          onChange={selectAll}
                          checked={groupsprint}
                          disabled={openCheckbox}
                        />
                        <h5>Sprint(task)Flow</h5>
                      </div>
                      <div className="column-table-e ">
                        <Checkbox
                          id="permission-kpi"
                          value="kpi"
                          onChange={selectAll}
                          checked={groupkpi}
                          disabled={openCheckbox}
                        />
                        <h5>KPI/Finance</h5>
                      </div>
                      <div className="column-table-f ">
                        <Checkbox
                          id="permission-approval"
                          value="approval"
                          onChange={selectAll}
                          checked={groupapp}
                          disabled={openCheckbox}
                        />
                        <h5>Approval</h5>
                      </div>
                      <div className="column-table-g ">
                        <h5>Delete</h5>
                      </div>
                    </div>
                  </div>
                  <div className="table-body">{Datarender()}</div>
                </div>
              </div>
            </div>
          </Form>
        </EditModal>
      </Form>
      <Modal
        maskClosable={false}
        visible={Modalmember}
        className="Modal"
        onOk={form2.submit}
        okText={'Save'}
        onCancel={cancleModalMember}
      >
        <Form id="modalEdit" name="modalEdit" form={form2} onFinish={onFinishEdit}>
          <div className="header-custom">
            <div className="subhead">
              <div className="sub-1">
                <img
                  className="imageStyle"
                  style={{ width: 42, height: 42 }}
                  src={userpicture}
                ></img>
              </div>
              <div className="sub-2">
                <div style={{ display: 'grid', marginRight: 8 }}>
                  <h2 className="cutter-text-line-1">
                    {firstNameEdit} {lastNameEdit}
                  </h2>
                </div>
                <h4 className="show-company-normal">Business : {shortnameCompany}</h4>
                {/* <h4 className="show-skill-normal">{skill} arnon skill</h4> */}
              </div>
            </div>
            <div>
              <Button
                id="btn_delete"
                className="BTN_ClassA"
                onClick={() => deleteMember()}
              >
                <DeleteOutlined className="Icon-color" />
                Delete
              </Button>
            </div>
          </div>
          <div className="body-custom">
            <div className="show-skill-responsive">
              <h4>{skill}</h4>
            </div>
            <h4>{firstNameEdit}'s Permission</h4>

            <Checkbox
              indeterminate={indeterminate}
              onChange={onCheckAllChange}
              checked={checkAll}
            >
              Check all
            </Checkbox>

            <Form.Item id="editPermission" name="editPermission">
              <Checkbox.Group style={{ width: '100%' }} onChange={onChangeCheckBoxMember}>
                <Row className="Row">
                  {listPermission.map((item) => (
                    <Checkbox value={item.id}>{item.title}</Checkbox>
                  ))}
                </Row>
              </Checkbox.Group>
            </Form.Item>
          </div>
        </Form>
      </Modal>
      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={modaldeleterowVisible}
        okText="Confirm"
        onOk={deleteRoleFunctional}
        onCancel={() => setModaldeleterowVisible(false)}
      >
        <CloseCircleOutlined className="CloseCircleOutlined" />
        <h2>Delete Role</h2>
        <h4>Are you sure you want to delete role ?</h4>
      </Modal>
    </RoleContainer>
  )
}
export default Role
